import { Skeleton } from '@knack/asterisk-react';

export function LoadingSkeleton() {
  return (
    <div className="relative z-10 h-full bg-default">
      <Skeleton className="h-full" />
    </div>
  );
}
